export default {"src":"/_next/static/media/icon_basket.f1c6d6bb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};